import React, { useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Card, Button, Alert, Spinner, Badge, Table } from 'react-bootstrap'
import { useAdminSystem } from 'api/hooks/use-admin-systems'
import AdminTabs from 'admin/shared/AdminTabs'

const SystemDetail = () => {
  const { id } = useParams()
  const { data: system, isLoading, error } = useAdminSystem({ id })
  const [activeTab, setActiveTab] = useState('details')

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">Error loading system: {error.message}</Alert>
  }

  if (!system) {
    return <Alert variant="warning">System not found.</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>{system.name}</h2>
        <div>
          <Button as={Link} to={`/admin/systems/${id}/edit`} variant="warning" className="me-2">Edit System</Button>
          <Button as={Link} to="/admin/systems" variant="light-primary">Back to List</Button>
        </div>
      </div>

      <AdminTabs
        tabs={[
          { name: 'Details', value: 'details' },
          { name: `Municipalities (${system.municipality_sections?.length || 0})`, value: 'municipalities' }
        ]}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {activeTab === 'details' && (
        <Card className="mb-4">
          <Card.Header><h5>System Information</h5></Card.Header>
          <Card.Body>
            <dl className="row mb-0">
              <dt className="col-sm-3">Name:</dt>
              <dd className="col-sm-9">{system.name}</dd>
              <dt className="col-sm-3">Company:</dt>
              <dd className="col-sm-9">{system.company || 'N/A'}</dd>
              <dt className="col-sm-3">System Table Columns:</dt>
              <dd className="col-sm-9"><Badge bg="primary">{system.system_table_columns_count}</Badge></dd>
            </dl>
          </Card.Body>
        </Card>
      )}

      {activeTab === 'municipalities' && (
        <Card>
          <Card.Body>
            {system.municipality_sections?.length > 0 ? (
              <Table bordered hover responsive>
                <thead>
                  <tr>
                    <th>Municipality</th>
                    <th>Module</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {system.municipality_sections.map((ms) => (
                    <tr key={ms.id}>
                      <td>{ms.municipality_name}</td>
                      <td><code>{ms.section_abbreviation}</code> {ms.section_name}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        <Button as={Link} to={`/admin/municipalities/${ms.municipality_id}`} variant="info" size="sm">View Municipality</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Alert variant="info" className="mb-0">No municipalities use this system.</Alert>
            )}
          </Card.Body>
        </Card>
      )}
    </div>
  )
}

export default SystemDetail
